<template>
  <div>
    <excel-row :data="data"></excel-row>

  </div>
</template>

<script>
import ExcelRow from "@/components/ExcelRow.vue";

export default {
  name: 'GongziDemo',
  components: {
    ExcelRow,
  },
  data() {
    return {
      data: {
        headers: "[{\"0\":\"序号\",\"1\":\"科室\",\"2\":\"户口性质\",\"3\":\"姓名\",\"4\":\"工资卡号\",\"5\":\"身份证号码\",\"6\":\"工资标准\",\"7\":\"岗位补贴\",\"8\":\"岗位基本奖\",\"9\":\"补发工资\",\"10\":\"补扣\",\"11\":\"其他扣发\",\"12\":\"代扣2012年五一节日补助\",\"13\":\"经济补偿金\",\"14\":\"2022.10\\n优质病房\\n津贴\",\"15\":\"2017.1增资\",\"16\":\"补发岗位基本奖差额\",\"17\":\"补发2012.03\\n优质病房\\n津贴\",\"18\":\"考勤\",\"20\":\"2022.10\\n奖金\",\"21\":\"其它\",\"22\":\"临时性岗位补贴\",\"23\":\"应发合计\",\"24\":\"缴费基数\",\"27\":\"养老保险（8%）\",\"28\":\"医疗保险（2%+3）\",\"29\":\"失业保险（0.5%）\",\"30\":\"住房公积金（12%）\",\"31\":\"调整个人保险及公积金\",\"32\":\"三险一金小计\",\"33\":\"扣税依据\",\"34\":\"扣税\",\"35\":\"工会会费\",\"36\":\"其他-调整\",\"37\":\"实发工资\"},{\"18\":\"扣发岗位基本奖\",\"19\":\"扣发工资\",\"24\":\"养老、失业\",\"25\":\"医疗\",\"26\":\"住房公积金\"}]",
        row: "{\"0\":\"95\",\"1\":\"体检中心\",\"2\":\"北京城镇\",\"3\":\"AAA\",\"4\":\"xxxx\",\"5\":\"xxxxx\",\"6\":\"2945.00\",\"8\":\"1800\",\"18\":\"-1800\",\"19\":\"-2945.00\",\"20\":\"500.00\",\"21\":\"2333.25\",\"23\":\"2833.25\",\"24\":\"5869\",\"25\":\"5869\",\"26\":\"2986\",\"27\":\"469.52\",\"28\":\"120.38\",\"29\":\"29.35\",\"30\":\"358\",\"31\":\"0.00\",\"32\":\"977.25\",\"37\":\"1856.00\"}"
      }
    }
  },
}
</script>

<style>
</style>
